import React from 'react';
import { Route } from 'react-router-dom';
import { AdminRoute } from './AdminRoute';
import { AdminLayout } from '../layouts/AdminLayout';
import { DashboardPage } from '../pages/admin/DashboardPage';
import { QuotesListPage } from '../pages/admin/QuotesListPage';
import { CompaniesListPage } from '../pages/admin/CompaniesListPage';
import { ClientsListPage } from '../pages/admin/ClientsListPage';
import { UsersListPage } from '../pages/admin/UsersListPage';
import { QuoteDetailPage } from '../pages/admin/QuoteDetailPage';

export const adminRoutes = (
  <Route element={<AdminRoute />}>
    <Route element={<AdminLayout />}>
      <Route path="/admin" element={<DashboardPage />} />
      <Route path="/admin/quotes" element={<QuotesListPage />} />
      <Route path="/admin/quotes/:id" element={<QuoteDetailPage />} />
      <Route path="/admin/companies" element={<CompaniesListPage />} />
      <Route path="/admin/clients" element={<ClientsListPage />} />
      <Route path="/admin/users" element={<UsersListPage />} />
    </Route>
  </Route>
);
